goog.provide("shadow.js.shim.module$src$svg$inform$cross_square_svg$default");
shadow.js.shim.module$src$svg$inform$cross_square_svg$default = shadow.js.shim.module$src$svg$inform$cross_square_svg.default;
